<template>
  <div class="ao__ig-container">
    <ClientOnly>
      <blockquote
        ref="blockquoteRef"
        class="instagram-media"
        :data-instgrm-permalink="permalink"
        data-instgrm-version="14"
        data-instgrm-captioned
      >
        <a :href="permalink" target="_blank" rel="noopener noreferrer">
          Zobrazit příspěvek na Instagramu
        </a>
      </blockquote>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, nextTick, ref } from 'vue'
import loadEmbedScript from '~/server/utils/request/loadEmbedScript'

const props = defineProps<{
  type?: string
  payload?: any
  parentIdent?: string
}>()

const blockquoteRef = ref<HTMLElement | null>(null)

const permalink = computed<string>(() => {
  const src: string = props.payload?.attributes?.src ?? ''
  if (!src) return ''
  try {
    const url = new URL(src)
    const segments = url.pathname
      .split('/')
      .map(segment => segment.trim())
      .filter(Boolean)

    const mediaTypeIndex = segments.findIndex(segment => ['p', 'reel', 'tv'].includes(segment))
    if (mediaTypeIndex !== -1 && segments[mediaTypeIndex + 1]) {
      const mediaType = segments[mediaTypeIndex]
      const mediaId = segments[mediaTypeIndex + 1]
      url.pathname = `/${mediaType}/${mediaId}/`
    } else {
      url.pathname = `/${segments.join('/')}${segments.length ? '/' : ''}`
    }

    url.search = ''
    url.hash = ''

    return url.toString()
  } catch {
    return src
  }
})

const processEmbeds = () => {
  if (typeof window === 'undefined') return
  const w = window as any
  if (w.instgrm?.Embeds?.process) {
    w.instgrm.Embeds.process()
  }
}

onMounted(async () => {
  if (typeof window === 'undefined') return
  await nextTick()

  const w = window as any
  if (w.instgrm?.Embeds?.process) {
    processEmbeds()
    return
  }

  loadEmbedScript(
    'instagram',
    'https://www.instagram.com/embed.js',
    {},
    () => {
      nextTick(processEmbeds)
    }
  )
})
</script>

<style lang="postcss">
.ao__ig-container {
  @apply my-6 w-full flex justify-center;

  .instagram-media {
    @apply mx-auto;
    background: #fff;
    border: 0;
    border-radius: 3px;
    box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.5), 0 1px 10px 0 rgba(0, 0, 0, 0.15);
    margin: 1px;
    max-width: 540px !important;
    min-width: 0 !important;
    padding: 0;
    width: min(calc(100% - 2px), 540px) !important;
  }
}
</style>
